import { CustomCheckbox } from "../ui";
import { useStateWithSearchParams } from "../../hooks";
import { QUERY_SEPARATOR } from "../../constant";

type Props = {
  id: string;
  isDisabled: boolean;
};

type SearchParams = {
  selected?: string;
};

export const RecommendedCheckbox = ({ id, isDisabled }: Props) => {
  const { searchDict, setSearchValue } = useStateWithSearchParams<SearchParams>(
    {
      selected: undefined,
    },
  );

  const selectedList = searchDict.selected?.split(QUERY_SEPARATOR) || [];
  const isSelected = selectedList.includes(id);

  const checkBoxHandler = () => {
    const selectedList = searchDict.selected?.split(QUERY_SEPARATOR) || [];
    const isSelected = selectedList.includes(id);

    if (isSelected)
      setSearchValue(
        "selected",
        selectedList.filter((el) => el !== id).join(QUERY_SEPARATOR),
      );
    else {
      selectedList.push(id);
      setSearchValue("selected", selectedList.join(QUERY_SEPARATOR));
    }
  };

  return (
    <CustomCheckbox
      checked={isSelected}
      onChange={checkBoxHandler}
      disabled={isDisabled}
    />
  );
};
